import { render, staticRenderFns } from "./HowToModal.vue?vue&type=template&id=a0b66b60"
import script from "./HowToModal.vue?vue&type=script&lang=js"
export * from "./HowToModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports